<div *ngIf="totalRowCount">
  <span class="ag-status-name-value-value"> Rows: </span>
  <span class="ag-status-name-value"> {{ filteredRowCount }} of {{ totalRowCount }} </span>
</div>
